import React from 'react';
import { Filters } from 'react-data-grid-addons';

const { AutoCompleteFilter } = Filters;

class BooleanFilter extends AutoCompleteFilter {
  constructor(props) {
    super(props);
    this.getOptions = this.getOptions.bind(this);
  }

  getOptions() {
    let options = [
      { value: 1, label: 'Oui' },
      { value: 0, label: 'Non' },
    ];
    return options;
  }
}

BooleanFilter.defaultProps = {
    multiSelection: false
};

export default BooleanFilter;



// WEBPACK FOOTER //
// ./src/Components/DataGrid/BooleanFilter.js